<template lang="html">
<div class="v-scope-home-oferta-el-fake">
<article class="oferta row-start aifs">

    <div class="contenedor-textos">

      <h3 class="empresa -backgroundLoad"></h3>

      <h2 class="title-dato -backgroundLoad"></h2>

      <p class="status -backgroundLoad"></p>
    
      <div class="info column-center">
        <p class="-fecha -backgroundLoad"></p>
        <p class="-lugar -backgroundLoad"></p>
      </div>

    </div>

  </article>
</div>
</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'oferta-el--fake',
    computed : {
      ...mapGetters({
        style : 'getStyles',
        colors : 'basicColors'
      }),      
    }
  }
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/oferta-el--fake.vue